import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";
import { useSelector } from "react-redux";

const initialState = {
    loading: true,
    error: '',
    success: '',
    List: [],
};

export const OrdersList = createAsyncThunk(
    'Orders',
    async (searchParams, { rejectWithValue }) => {
        // Construct URL safely using query parameters instead of string interpolation
        const safeUrl = 
        `orders/list?${new URLSearchParams(searchParams).toString()}`;

        try {
            const res = await dataService.GetAPI(safeUrl);
            return res;
        } catch (error) {
            // Log error or send notification
            console.error('Error fetching orders:', error);
            return rejectWithValue({ message: error });
        }
    }
);

const OrderListSlice = createSlice({
    name: 'admin-user',
    initialState,
    reducers: {},
    extraReducers: {
        [OrdersList.pending]: (state) => {
            state.loading = true;
            state.error = '';
        },
        [OrdersList.fulfilled]: (state, action) => {
            state.loading = false;
            if (action.payload?.data?.success_status) {
                state.List = action.payload?.data;
                state.loading = false;
            } else {
                state.error = action.payload?.data?.message || 'Order retrieval failed';
            }
        },
        [OrdersList.rejected]: (state, { payload }) => {
            state.loading = false;
            state.error = payload?.message || 'An unexpected error occurred';

            // Send error message to error logger or notification system
            // Replace `console.error` with your preferred error handling mechanism
            console.log('Error fetching orders:', payload?.message);
        },
    },
});

export const { HandleOrderCategories } = OrderListSlice.actions;
export default OrderListSlice.reducer;
